import { motion } from "framer-motion";

const DIMENSIONS = ["Interests", "Personality", "Reasoning", "Values", "Strengths", "Leadership", "Work Style", "Innovation"];
const FAMILIES = [
  "Healthcare", "Technology", "Research", "Government", "Defence", "Finance",
  "Law", "Entrepreneurship", "Education", "Design", "Community Impact", "Aviation", "Engineering",
];

export default function NodeGraph() {
  const innerRadius = 130;
  const outerRadius = 220;

  return (
    <div className="relative w-full aspect-square max-w-xl mx-auto" data-testid="signature-node-graph">
      <div className="absolute inset-0 rounded-full border border-slate-700/40" />
      <div className="absolute inset-8 rounded-full border border-slate-700/30 animate-[spin_60s_linear_infinite]" />

      {FAMILIES.map((f, i) => {
        const angle = (i / FAMILIES.length) * 2 * Math.PI;
        const x = 50 + (outerRadius / 5) * Math.cos(angle);
        const y = 50 + (outerRadius / 5) * Math.sin(angle);
        return (
          <motion.div
            key={f}
            className="absolute text-[10px] sm:text-xs text-slate-400 whitespace-nowrap px-2 py-1 rounded-full bg-slate-900/70 border border-slate-700/50"
            style={{ left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" }}
            animate={{ opacity: [0.4, 0.9, 0.4] }}
            transition={{ duration: 4, repeat: Infinity, delay: i * 0.2 }}
          >
            {f}
          </motion.div>
        );
      })}

      {DIMENSIONS.map((d, i) => {
        const angle = (i / DIMENSIONS.length) * 2 * Math.PI;
        const x = 50 + (innerRadius / 5) * Math.cos(angle);
        const y = 50 + (innerRadius / 5) * Math.sin(angle);
        return (
          <svg key={`line-${d}`} className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
            <motion.line
              x1="50" y1="50" x2={x} y2={y}
              stroke="url(#grad)" strokeWidth="0.4"
              initial={{ pathLength: 0, opacity: 0 }}
              animate={{ pathLength: 1, opacity: 0.7 }}
              transition={{ duration: 1.5, delay: i * 0.15 }}
            />
            <defs>
              <linearGradient id="grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#4338CA" />
                <stop offset="100%" stopColor="#06B6D4" />
              </linearGradient>
            </defs>
          </svg>
        );
      })}

      {DIMENSIONS.map((d, i) => {
        const angle = (i / DIMENSIONS.length) * 2 * Math.PI;
        const x = 50 + (innerRadius / 5) * Math.cos(angle);
        const y = 50 + (innerRadius / 5) * Math.sin(angle);
        return (
          <motion.div
            key={d}
            className="absolute text-xs font-medium text-slate-200 bg-slate-800/90 border border-indigo-500/40 rounded-full px-3 py-1.5 whitespace-nowrap"
            style={{ left: `${x}%`, top: `${y}%`, transform: "translate(-50%, -50%)" }}
            animate={{ y: [0, -4, 0] }}
            transition={{ duration: 3, repeat: Infinity, delay: i * 0.3 }}
          >
            {d}
          </motion.div>
        );
      })}

      <motion.div
        className="absolute rounded-full bg-gradient-to-br from-indigo-500 to-cyan-400 flex items-center justify-center shadow-[0_0_60px_rgba(67,56,202,0.6)]"
        style={{ left: "50%", top: "50%", width: "22%", height: "22%", transform: "translate(-50%, -50%)" }}
        animate={{ scale: [1, 1.06, 1] }}
        transition={{ duration: 3, repeat: Infinity }}
      >
        <span className="font-heading font-bold text-white text-lg sm:text-2xl">YOU</span>
      </motion.div>
    </div>
  );
}
